interface LibrarySectionHeaderProps {
  onDoneClick?: () => void;
}

/**
 * LibrarySectionHeader Component
 * 
 * Displays "Your List" title and "DONE" button with responsive design.
 * 
 * Responsive Behavior:
 * - Title: Scales from 32px to 34px to 36px
 * - DONE button: Maintains minimum 44×44px touch target
 * - Button text: Scales from 12px to 13px to 14px
 * 
 * Design specs from Figma node 1659-8123 with responsive enhancements
 */
export default function LibrarySectionHeader({ onDoneClick }: LibrarySectionHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-2 sm:mb-3 md:mb-4">
      {/* Section Title - Responsive typography */}
      {/* <h1 
        className="text-[32px] sm:text-[34px] md:text-[36px] font-bold text-[#1B2831]" 
        style={{ letterSpacing: '-1.28px' }}
      >
        Your saved sparks
      </h1> */}
      <div/>

      {/* DONE Button - Responsive typography with touch target */}
      <button 
        onClick={onDoneClick}
        className="text-[12px] sm:text-[13px] md:text-[14px] font-black uppercase text-[#007CAD] hover:text-[#005f8a] transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
        style={{ letterSpacing: '0.72px' }}
        aria-label="Done viewing library, return to home"
      >
        DONE
      </button>
    </div>
  );
}